/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { SolutionsRequestDto } from '../models/SolutionsRequestDto';
import type { SolutionsResponseDto } from '../models/SolutionsResponseDto';

export class SolutionsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Solutions
   * Get ranked benefit solutions for an employee with snapshot tracking.
   *
   * The handler is the single fetch point for the user profile: it loads
   * the profile from the monolith once, then threads it through both the
   * inference layer (which needs it to filter orphan per-dependent
   * inputs) and the solutions service (which forwards it to the engine).
   * @param requestBody
   * @param xUserId
   * @returns SolutionsResponseDto Successful Response
   * @throws ApiError
   */
  public getSolutionsDiscoveryV1SolutionsPost(
    requestBody: SolutionsRequestDto,
    xUserId?: string | null
  ): CancelablePromise<SolutionsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/discovery/v1/solutions',
      headers: {
        'X-User-ID': xUserId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
